export const data = [
	{
		id: 1,
		subject: "CECS 328 - ALGORITHMS",
		description: "Greedy algorithms, dynamic programming, divide and conquer, network flow, approximation algorithms, NP-complete problems. Programming projects to exemplify these concepts.",
	},
	{
		id: 2,
		subject: "CECS 274 - DATA STRUCTURES",
		description: "Topics include lists, hash tables, binary trees, balanced trees, heaps, sorting-algorithms, graphs, external memory searching.",
	},
	{
		id: 3,
		subject: "CECS 323 - DATABASE FUNDAMENTALS",
		description: "Fundamental topics on database management. Topics include entity-relationship models, database design, data definition language, the relational model, data manipulation language, database application programming and normalization.",
	},
	{
		id: 4,
		subject: "CECS 277 - OBJECT ORIENTED APPLICATION DEVELOPMENT",
		description: "Object oriented programming and design for large scale software. Class design, interfaces, inheritance, and polymorphism. Robust programming with exceptions, streams, iterators, and testing.",
	},
	{
		id: 5,
		subject: "CECS 341 - COMPUTER ARCHITECHTURE AND ORGANIZATION",
		description: "Basic computer architecture and organization, instruction set architecture, central processing unit, processor¿s datapath, arithmetic and logic unit, processor performance, pipelined processors, memory systems, cache memory organization, virtual memory, I/O systems, processor parallelism, and multicore processor architectures.",
	},
	{
		id: 6,
		subject: "CECS 229 - DISCRETE STRUCTRES WITH COMPUTING APPLICATIONS",
		description: "Topics include applications of computer arithmetic and matrices in computer systems.",
	},
	{
		id: 7,
		subject: "CECS 343 - INTRO TO SOFTWARE ENGINEERING",
		description: "Topics include applications of computer arithmetic and matrices in computer systems.",
	},
	{
		id: 8,
		subject: "CECS 326 - OPERATING SYSTEMS",
		description: "Topics include applications of computer arithmetic and matrices in computer systems.",
	},

];